import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-hcphome',
  templateUrl: './hcphome.component.html',
  styleUrls: ['./hcphome.component.scss']
})
export class HcphomeComponent implements OnInit {
  //highlight: boolean = true;
  //count: any;
  // imgPath:string;
  // toolTipText: string;
  constructor() { }

  toolTipText1: string = "Factor XII is the first protein activated²";
  imgPath1: string = "/assets/img/1.png"
  highlight1: boolean = false;

  toolTipText2: string = "Activated factor XIIa (factor XIIa) converts prekallikrein to kallikrein when C1 esterase inhibitor (C1-INH) is missing or dysfunctional²";
  imgPath2: string = "/assets/img/2.png"
  highlight2: boolean = false;

  toolTipText3: string = "Factor XIIa and plasma kallikrein cleave factor XII, generating additional factor XIIa in a feedback loop. A deficiency or dysfunction of C1-INH allows for dysregulated activation of the pathway.³˒⁴";
  imgPath3: string = "/assets/img/3.png"
  highlight3: boolean = false;

  toolTipText4: string = "In response, kallikrein cleaves high-molecular-weight kininogen (HMWK) leading to the release of bradykinin³";
  imgPath4: string = "/assets/img/4.png"
  highlight4: boolean = false;

  toolTipText5: string = "Bradykinin binds to B2 receptors promoting vascular permeability and edema—an HAE attack⁴";
  imgPath5: string = "/assets/img/5.png"
  highlight5: boolean = false;
  modalOpen: boolean = true;
  showRing(event,id:string){
    if(id == "highlight1"){
      this.highlight1 = !this.highlight1;
      this.highlight2 = false;
      this.highlight3 = false;
      this.highlight4 = false;
      this.highlight5 = false;
    }
    else if(id == "highlight2"){
      this.highlight1 = false;
      this.highlight2 = !this.highlight2;
      this.highlight3 = false;
      this.highlight4 = false;
      this.highlight5 = false;
    }
    else if(id == "highlight3"){
      this.highlight1 = false;
      this.highlight2 = false;
      this.highlight3 = !this.highlight3;
      this.highlight4 = false;
      this.highlight5 = false;
    }
    else if(id == "highlight4"){
      this.highlight1 = false;
      this.highlight2 = false;
      this.highlight3 = false;
      this.highlight4 = !this.highlight4;
      this.highlight5 = false;
    }
    else {
      this.highlight1 = false;
      this.highlight2 = false;
      this.highlight3 = false;
      this.highlight4 = false;
      this.highlight5 = !this.highlight5;
    }
    // if(event.target.nextElementSibling.hidden){
    //   event.target.nextElementSibling.hidden = !event.target.nextElementSibling.hidden;
    // }
  }
  // close(event){
  //   this.mobileTooltipModal = !this.mobileTooltipModal;
  // }
  
  popupclose() {
    this.highlight1 = false;
    this.highlight2 = false;
    this.highlight3 = false;
    this.highlight4 = false;
    this.highlight5 = false;
  }
  hpmodalClose(){
    this.modalOpen = false;
  }
  scroll(id: string){
    document.getElementById(id).scrollIntoView({behavior: 'smooth', block: "start", inline: "nearest"});
  }
  ngOnInit() {
  }

}
